module.exports = __webpack_public_path__ + "img/esc.917e81bf.svg";